import React, { useState } from 'react';
import { Table, Row, Col, ColumnType, Button } from '@digital/ui';
import { currencyFormat } from '@app/helpers/numbers';
import { dateTimeFormat } from '@app/helpers/dateTimeFormats';
import moment from 'moment';
import { Tooltip } from 'antd';
import { viewArquivoAutorizacao, downloadArquivoAutorizacao } from '@app/api/autorizacaoPagamento/autorizacao';
import ModalJustificativas from './modalJustificativas';
import ModalAnexarNovoDocumento from './modalAnexarNovoDocumento';
import ModalSolicitarSubstituicao from './modalSolicitarSubstituicao';
import ModalAnexarCartaCorrecao from './modalAnexarCartaCorrecao';
import ModalAcatarSubstituicao from './modalAcatarSubstituicao';
import ModalReenviar from './modalReenviar';
import ModalRejeitarSubstituicao from './modalRejeitarSubstituicao';
import ModalSubstituirArquivo from './modalSubstituirArquivo';
import { hasPermission } from '@app/helpers/permissions';
import { getLoggedIsMRN } from '@app/helpers';

const DocumentosCobrancaTable = (props: any) => {
    const { arquivos, setUpdate, usuarioLogadoFinanceiroDoContratoFornecedor } = props;

    const [isMRN] = useState<boolean>(getLoggedIsMRN());

    const column = [
        {
            title: 'Número',
            dataIndex: 'numero',
            width: '10%'
        },
        {
            title: 'Valor',
            dataIndex: 'valor',
            render: (text, record) => currencyFormat(record.valor)
        },
        {
            title: 'Data Emissão',
            dataIndex: 'dataEmissao',
            type: ColumnType.Date,
            width: '10%'
        },
        {
            title: 'Arquivo',
            dataIndex: 'nome',
        },
        {
            title: 'Inclusão',
            dataIndex: 'dataInclusao',
            render: (text, record) => moment(record.dataInclusao).format(dateTimeFormat)
        },
        {
            title: 'Responsável',
            dataIndex: 'responsavel'
        },
        {
            title: 'Status',
            dataIndex: 'statusArquivoAutorizacaoId',
            render: (text, record) => record.statusArquivoAutorizacao.nome
        },
        {
            title: 'Ações',
            render: (text, record) => (
                <>
                    {
                        (record.nome.split('.')[1] === 'pdf' ?
                            <Tooltip title="Visualizar Arquivo">
                                <Button
                                    onClick={() => {
                                        viewArquivoAutorizacao(record.id);
                                    }}
                                    icon="files-view_file"
                                    name="btnVisualizarArquivo"
                                />
                            </Tooltip>
                            :
                            <Tooltip title="Baixar Arquivo">
                                <Button
                                    onClick={() => {
                                        downloadArquivoAutorizacao(record.id, record.nome);
                                    }}
                                    icon="ui-download"
                                    name="btnBaixarArquivo"
                                />
                            </Tooltip>
                        )
                    }
                    {
                        (record.statusArquivoAutorizacao.codigo === 1 ?
                            <>
                                {
                                    // hasPermission(['MEDICAO_AUTORIZACAO_PAGAMENTO_EDITAR']) && isMRN ? <> <ModalSolicitarCancelamentoSubstituicao setUpdate={setUpdate} arquivoAutorizacaoId={record.id} /> </> : null
                                }
                                {
                                    // hasPermission(['MEDICAO_AUTORIZACAO_PAGAMENTO_EDITAR']) && isMRN ? <> <ModalSolicitarCorrecao setUpdate={setUpdate} arquivoAutorizacaoId={record.id} /> </> : null
                                }
                                {
                                    usuarioLogadoFinanceiroDoContratoFornecedor || hasPermission(['SGC_CADASTRAR_SUBSTITUIR_NF']) ? <> <ModalSolicitarSubstituicao setUpdate={setUpdate} arquivoAutorizacaoId={record.id} /> </> : null
                                }
                            </>
                            : null)
                    }
                    {
                        (record.statusArquivoAutorizacao.codigo === 2 ?
                            <>
                                {
                                    usuarioLogadoFinanceiroDoContratoFornecedor || hasPermission(['SGC_CADASTRAR_SUBSTITUIR_NF'])? <> <ModalAnexarNovoDocumento setUpdate={setUpdate} arquivoAutorizacaoId={record.id} /> </> : null
                                }
                            </>
                            : null)
                    }
                    {
                        (record.statusArquivoAutorizacao.codigo === 3 ?
                            <>
                                {
                                    usuarioLogadoFinanceiroDoContratoFornecedor || hasPermission(['SGC_CADASTRAR_SUBSTITUIR_NF'])? <> <ModalAnexarCartaCorrecao setUpdate={setUpdate} arquivoAutorizacaoId={record.id} /> </> : null
                                }
                            </>
                            : null)
                    }
                    {
                        (record.statusArquivoAutorizacao.codigo === 4 ?
                            <>
                                {
                                    hasPermission(['MEDICAO_AUTORIZACAO_PAGAMENTO_EDITAR']) && isMRN ? <>  <ModalAcatarSubstituicao setUpdate={setUpdate} arquivoAutorizacaoId={record.id} /> </> : null
                                }
                                {
                                    hasPermission(['MEDICAO_AUTORIZACAO_PAGAMENTO_EDITAR']) && isMRN ? <>  <ModalRejeitarSubstituicao setUpdate={setUpdate} arquivoAutorizacaoId={record.id} />  </> : null
                                }
                            </>
                            : null)
                    }
                    {
                        (record.statusArquivoAutorizacao.codigo === 5 ?
                            <>
                                {
                                    usuarioLogadoFinanceiroDoContratoFornecedor || hasPermission(['SGC_CADASTRAR_SUBSTITUIR_NF'])? <> <ModalSubstituirArquivo setUpdate={setUpdate} arquivoAutorizacaoId={record.id} /> </> : null
                                }
                            </>
                            : null)
                    }
                    {
                        (record.statusArquivoAutorizacao.codigo === 8 ?
                            <>
                                {
                                    hasPermission(['MEDICAO_AUTORIZACAO_PAGAMENTO_EDITAR']) && isMRN ? <> <ModalSubstituirArquivo setUpdate={setUpdate} arquivoAutorizacaoId={record.id} /> </> : null
                                }
                                {
                                    hasPermission(['MEDICAO_AUTORIZACAO_PAGAMENTO_EDITAR']) && isMRN ? <> <ModalReenviar setUpdate={setUpdate} arquivoAutorizacaoId={record.id} /> </> : null
                                }
                            </>
                            : null)
                    }
                    {
                        <>
                            {
                                (usuarioLogadoFinanceiroDoContratoFornecedor || hasPermission(['SGC_CADASTRAR_SUBSTITUIR_NF'])) || (hasPermission(['MEDICAO_AUTORIZACAO_PAGAMENTO_EDITAR']) && isMRN) ? <>  <ModalJustificativas arquivoAutorizacaoId={record.id} contemComentario={record.contemComentario} /> </> : null
                            }
                        </>
                    }
                </>
            )
        }
    ];

    return (
        <boo>
            <Row>
                <Col>
                    <Table columns={column} dataSource={arquivos} />
                </Col>
            </Row>
        </boolean>
    );
};
export default DocumentosCobrancaTable;